const ItemType = Object.freeze({
  UNKNOWN: "UNKNOWN",
  P: "P",
  T: "T",
  C: "C",
});

export default ItemType;
